import React, { useMemo, useState } from "react"
import { graphql, useSubscription } from "react-relay"

import { CopyAccountLoaderSubscription } from "./__generated__/CopyAccountLoaderSubscription.graphql"

import { blockPage, unblockPage } from "~/containers/RunnApp"
import { showToast } from "~/containers/ToasterContainer"

import LoadingModal from "./LoadingModal"

const COPY_STATUS_SUBSCRIPTION = graphql`
  subscription CopyAccountLoaderSubscription {
    current_account {
      id
      copy_status
      copy_started_at
    }
  }
`

const CopyAccountLoader = () => {
  const [showModal, setShowModal] = useState(false)

  useSubscription<CopyAccountLoaderSubscription>(
    useMemo(
      () => ({
        subscription: COPY_STATUS_SUBSCRIPTION,
        variables: {},
        onNext: (data) => {
          const copyStartedAt = data.current_account?.copy_started_at
          const copyStatus = data.current_account?.copy_status
          if (
            !showModal &&
            copyStatus === "in_progress" &&
            copyStartedAt &&
            copyStartedAt - Date.now() / 1000 < 180
          ) {
            setShowModal(true)
            blockPage()
          } else if (showModal) {
            // assume copy is successful if copy_status is null
            if (!copyStatus) {
              window.location.reload()
            } else if (
              copyStatus === "failed" ||
              // incase the node container gets killed and we miss the copy_status update
              (copyStartedAt && copyStartedAt - Date.now() / 1000 > 180)
            ) {
              unblockPage()
              setShowModal(false)
              showToast({
                message:
                  "Failed to copy account data. Please try again or contact support if the issue persists.",
              })
            }
          }
        },
      }),
      [showModal],
    ),
  )

  if (!showModal) {
    return null
  }

  return (
    <LoadingModal
      showModal={showModal}
      modalText="Copying data from your Live Account..."
    />
  )
}

export default CopyAccountLoader
